'use client'

import React, { createContext, useState, useContext, ReactNode, useMemo } from 'react';

interface FooterContextType {
    isFooterVisible: boolean;
    setIsFooterVisible: (isVisible: boolean) => void;
}

const FooterContext = createContext<FooterContextType | undefined>(undefined);

export const FooterProvider = ({ children }: { children: ReactNode }) => {
    const [isFooterVisible, setIsFooterVisible] = useState<boolean>(true); 

    const value = useMemo(() => ({
        isFooterVisible,
        setIsFooterVisible
    }), [isFooterVisible]);

    return (
        <FooterContext.Provider value={value}>
            {children}
        </FooterContext.Provider>
    );
};

export const useFooter = (): FooterContextType => {
    const context = useContext(FooterContext);
    if (context === undefined) {
        throw new Error('useFooter must be used within a FooterProvider');
    }
    return context;
};